/*
  Marking a link or button with [data-throttle-click] prevents rapid double-clicks.
  First click fires immediately, subsequent clicks are ignored for the throttle duration.
  The element gets is-loading class while throttled for visual feedback.

  Default throttle: 2000ms
  Custom throttle: data-throttle-click="3000" (ms)
*/

const DEFAULT_THROTTLE_MS = 2000;

document.addEventListener("click", (e) => {
  const trigger = e.target.closest("[data-throttle-click]");
  if (!trigger) return;

  if (trigger.hasAttribute("data-throttle-active")) {
    e.preventDefault();
    e.stopPropagation();
    return;
  }

  const throttleMs =
    parseInt(trigger.getAttribute("data-throttle-click"), 10) || DEFAULT_THROTTLE_MS;

  trigger.setAttribute("data-throttle-active", "");
  trigger.classList.add("is-loading");

  setTimeout(() => {
    trigger.removeAttribute("data-throttle-active");
    trigger.classList.remove("is-loading");
  }, throttleMs);
});
